module.exports = __webpack_public_path__ + "static/media/zhiboyuan.a788d5a6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/program/zhiboyuan.jpg
// module id = 1198
// module chunks = 114